import request from '@/utils/request'
//获取table表格数据
export function getList (data) {
  return request({
    url: `/fiveRecord/page`,
    method: 'post',
    data,
  })
}
//获取所有老师
export function getTeachers () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}
//获取所有学生
export function getStudents () {
  return request({
    url: `student/getStudentList`,
    method: 'get',
  })
}

export function getStudentsType (type) {
  return request({
    url: `student/getStudentList`,
    method: 'post',
    data:{
      studentType: type,
      state:1,
    }
  })
}

//修改首次课成功情况
export function changeFirstClass (data) {
  return request({
    url: `/firstRecord/update`,
    method: 'post',
    data
  })
}
//修改销售完成情况
export function markeStatus (data) {
  return request({
    url: `/fiveRecord/update`,
    method: 'post',
    data
  })
}
//获取所有科目
export function getSubject () {
  return request({
    url: `schedule/categorylist`,
    method: 'get',
  })
}
//详情
export function getdeta (id) {
  return request({
    url: `fiveRecord/detail/${id}`,
    method: 'POST',
  })
}



export function getcategoryList () {
  return request({
    url: `category/list`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/fiveClassApi.js